// extracted by mini-css-extract-plugin
export default {"skipModal":"SkipModal_skipModal__iEs6o","header":"SkipModal_header__dXGGM","buttons":"SkipModal_buttons__57CIH","close":"SkipModal_close__o5qMp"};